import { themeEstra } from 'app/styles/themeEstra'
import { QuotationRequestStatus, QuotationStatus } from 'EstraSuppliers'

type QuotationExtendedStatus = QuotationRequestStatus | QuotationStatus

export const QuotationStatusDictionary: {
  [key in QuotationExtendedStatus]: string
} = {
  requested: 'Nuova',
  pending: 'In elaborazione',
  approved: 'In elaborazione',
  rejected: 'Rifiutato',
  canceled: 'Annullato',
  sent: 'In elaborazione',
  new: 'In elaborazione',
  blocked: 'In elaborazione',
  in_progress: 'In elaborazione',
  completed: 'Completato',
}

export const statusTextColors: { [key in QuotationExtendedStatus]: string } = {
  requested: themeEstra.color.primari.neroEstra,
  pending: themeEstra.color.primari.arancione,
  approved: themeEstra.color.primari.arancione,
  rejected: themeEstra.color.primari.fucsia,
  canceled: themeEstra.color.primari.grigioEstra,
  sent: themeEstra.color.primari.arancione,
  new: themeEstra.color.primari.arancione,
  blocked: themeEstra.color.primari.arancione,
  in_progress: themeEstra.color.primari.arancione,
  completed: themeEstra.color.primari.verde,
}
